import api from './api';

export interface User {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'client';
  clientId?: string; // ID do cliente (para usuários de cliente)
  userRole?: string; // Perfil específico (admin, gerente, visualizador, etc)
  permissions?: string[]; // Permissões de visualização: ["pmoc", "nf", "proposta"]
}

export interface LoginResponse {
  token: string;
  user: User;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', { email, password });
    return response.data;
  },

  async ssoLogin(token: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/sso', { token });
    return response.data;
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },

  async me(): Promise<User> {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },
};
